// frontend/src/components/leveling/TierAvatar.js
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { tierDisplay } from "../../lib/leveling";
import { cn } from "../../lib/utils";

/**
 * Avatar wrapped with a tier-colored ring, optionally with a level badge overlay.
 *
 * Props:
 *   src, alt, fallback: avatar content
 *   tier: "rookie" | "bronze" | "silver" | "gold" | "platinum" | "diamond" | "legend"
 *   level: optional number — when set, a small circular badge with the level
 *          number is rendered at the bottom-right of the avatar
 *   size: tailwind size class (default "h-10 w-10")
 *   levelBadgeSize: override the badge sizing (default scales for h-10 avatar)
 *   className: extra classes
 */
export default function TierAvatar({
  src,
  alt,
  fallback,
  tier = "rookie",
  level,
  size = "h-10 w-10",
  levelBadgeSize = "h-[18px] min-w-[18px] px-[3px] text-[10px]",
  className = "",
  fallbackStyle,
  fallbackClassName = "",
}) {
  const td = tierDisplay(tier);
  const isLegend = tier === "legend";
  const showBadge = level != null;
  return (
    <div
      className={cn(
        "relative inline-flex items-center justify-center rounded-full",
        td.ringClass,
        td.glow,
        isLegend && "tier-legend-ring",
        className,
      )}
    >
      <Avatar className={size}>
        {src ? <AvatarImage src={src} alt={alt} /> : null}
        <AvatarFallback style={fallbackStyle} className={fallbackClassName}>
          {fallback}
        </AvatarFallback>
      </Avatar>
      {showBadge ? (
        <span
          className={cn(
            "absolute -bottom-1 -right-1 inline-flex items-center justify-center rounded-full font-bold tabular-nums leading-none border-2",
            levelBadgeSize,
          )}
          style={{
            background: "#0a0a0a",
            borderColor: td.color,
            color: td.color,
          }}
        >
          {level}
        </span>
      ) : null}
    </div>
  );
}
